module.exports = __webpack_public_path__ + "static/media/email_ilustration.484dd074.svg";